import { PlacementContentDef } from '@ads-ep/fetch-api-client';

export const cleanMetricsContent = (content: PlacementContentDef)=>({
  id: content.id,
  contentType: content.contentType,
  metadata: content.metadata,
});
